import { Outlet } from "@tanstack/react-router";

import { useNavigationManager } from "~/managers/use-navigation-manager";
import { Header } from "../layout/header";
import { MobileMenu } from "../layout/mobile-menu";
import { Sidebar } from "../layout/sidebar";

export default function AdminView() {
  const { adminItems } = useNavigationManager();
  return (
    <>
      <Header />
      <div className="flex flex-row flex-1 relative overflow-hidden">
        <Sidebar navItems={adminItems} />
        <MobileMenu navItems={adminItems} />

        <div className="flex-1 p-4 max-w-7xl mx-auto w-full overflow-auto">
          <Outlet />
        </div>
      </div>
    </>
  );
}
